module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/ylsf.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fylsf.png
// module id = swag
// module chunks = 93